"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTypeKeys = exports.TransmissionMethodKeys = exports.BatonStatus = exports.BatonEnv = void 0;
var BatonEnv;
(function (BatonEnv) {
    BatonEnv["INTEGRATION"] = "integration";
    BatonEnv["PRODUCTION"] = "production";
})(BatonEnv = exports.BatonEnv || (exports.BatonEnv = {}));
var BatonStatus;
(function (BatonStatus) {
    BatonStatus["OPEN"] = "open";
    BatonStatus["CLOSE"] = "closed";
    BatonStatus["FAILED"] = "failed";
    BatonStatus["LOCKED"] = "locked";
    BatonStatus["PREPARING"] = "preparing";
})(BatonStatus = exports.BatonStatus || (exports.BatonStatus = {}));
var TransmissionMethodKeys;
(function (TransmissionMethodKeys) {
    TransmissionMethodKeys["FileTransfer"] = "fileTransfer";
    TransmissionMethodKeys["Email"] = "email";
    TransmissionMethodKeys["SiteFlow"] = "siteFlow";
    TransmissionMethodKeys["EnfocusSwitch"] = "enfocusSwitch";
    TransmissionMethodKeys["PromoStandards"] = "promoStandards";
    TransmissionMethodKeys["ApiPoll"] = "apiPoll";
    TransmissionMethodKeys["ApiPush"] = "apiPush";
    TransmissionMethodKeys["Pom"] = "pom";
})(TransmissionMethodKeys = exports.TransmissionMethodKeys || (exports.TransmissionMethodKeys = {}));
var ActionTypeKeys;
(function (ActionTypeKeys) {
    ActionTypeKeys["OrderRequest"] = "orderRequest";
    ActionTypeKeys["CancellationRequest"] = "cancellationRequest";
    ActionTypeKeys["AddressChangeRequest"] = "addressChangeRequest";
    ActionTypeKeys["ArtworkChangeRequest"] = "artworkChangeRequest";
    ActionTypeKeys["ShipmentRequirementChangeRequest"] = "shipmentRequirementChangeRequest";
})(ActionTypeKeys = exports.ActionTypeKeys || (exports.ActionTypeKeys = {}));
